import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import i18n from "i18next";

import {
  useActiveLangs,
  useClientAnonymityInfo,
  useMenuProxy,
  usePageContent,
  useRedirect,
  useSetCurrentDate,
} from "../hooks";
import { useCountries } from "../hooks/useCountries";
import { useHTMLCode } from "../hooks/useHTMLCode";

import { Footer, Header } from "../components";
import ToastNotification from "../components/common/ToastNotification";
import MetaDate from "../components/meta-date";
import { LayoutLoader } from "../components/ui/LayoutLoader/LayoutLoader";

import { LayoutWrapper, Main } from "./IndexLayout.styled";

export const IndexLayout = () => {
  const lang = i18n.language;

  useRedirect();

  usePageContent();

  useClientAnonymityInfo();

  useMenuProxy(lang);

  useCountries(lang);

  useSetCurrentDate();

  useHTMLCode();

  useActiveLangs();

  return (
    <>
      <MetaDate />

      <LayoutWrapper>
        <Header />

        <Main>
          <Suspense fallback={<LayoutLoader />}>
            <Outlet />
          </Suspense>
        </Main>

        <Footer />
      </LayoutWrapper>

      <ToastNotification />
    </>
  );
};
